import PreviewIcon from '@mui/icons-material/Preview'
import { Button } from '@mui/material'
import { hasUserRight } from '@src/contexts/AppContext'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'; // #62287
import { EUserRights, merchantDashboardUrl } from '@src/data/types/Constants'
import { useMemo, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  merchantId: string
}

const MerchantDashboardAccess = ({ merchantId }: Props): JSX.Element | null => {
  const { t } = useTranslation()
  const [featureFlags] = useFeatureFlags() // #62287

  const dashboardUrl = useMemo(() => {
    const u = new URL(merchantDashboardUrl)
    u.searchParams.set('targetMerchantId', merchantId)
    return u.toString()
  }, [merchantId])

  if (!hasUserRight(EUserRights.canViewMerchantDashboard)) return null
  if (!featureFlags?.enableMerchantDashboardAccessFromMerchants) return null // #62287

  return (
    <Button
      component="a"
      href={dashboardUrl}
      target="_blank"
      rel="noopener noreferrer"
      startIcon={<PreviewIcon />}
      variant="outlined"
      color="primary"
    >
      {t('merchant.viewMerchantDashboard')}
    </Button>
  )
}

export default MerchantDashboardAccess
